<template>
    <div class="test-sentry">
        <el-alert
            title="注意:该页面仅用作sentry测试使用"
            type="warning"
            :closable="false">
        </el-alert>

        <div class="mt20">
            <el-button @click="triggerError" size="small">触发错误</el-button>
            <el-button @click="triggerCustomError" size="small">触发自定义错误</el-button>
            <el-button @click="triggerCustomInfo" size="small">触发自定义消息文本</el-button>
        </div>


    </div>
</template>

<script>
export default {
    data() {
        return {}
    },

    computed: {},

    methods: {
        triggerError() {
            console.log(Hello)
        },
        triggerCustomError() {
            Sentry.captureException('A custom error: '+ ~~new Date());
        },
        triggerCustomInfo() {
            Sentry.captureMessage('Custom Message: '+ ~~new Date());
        },
    },
}
</script>

<style scoped lang="scss">
.test-sentry {
    padding: 20px;
    background-color: #fff;
}
</style>
